import { render, staticRenderFns } from "./Curriculo.vue?vue&type=template&id=8af2f5da"
import script from "./Curriculo.vue?vue&type=script&lang=js"
export * from "./Curriculo.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./Curriculo.vue?vue&type=style&index=1&id=8af2f5da&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports